<h3 mat-dialog-title>{{ data.title }}</h3>

@if (data.content) {
  <mat-dialog-content>
    <ng-container [ngTemplateOutlet]="data.content"></ng-container>
  </mat-dialog-content>
}

<mat-dialog-actions>
  <ui-button (click)="onNoClick()" buttonStyle="text">{{ data.decline }}</ui-button>
  <ui-button (click)="onYesClick()" buttonStyle="filled">{{ data.confirm }}</ui-button>
</mat-dialog-actions>
